export default "__VITE_ASSET__7bitgBhZ__"